// loginCredenciales.ts — limpieza del correo que se envía al login.
//
// Round 2026-10-28. Los teclados del celular agregan un espacio al final al elegir una sugerencia, y
// los portapapeles traen espacios no separables o caracteres invisibles. El backend ya recorta y pasa
// a minúsculas el correo; esto solo evita enviar basura invisible. La CLAVE no se toca: un espacio
// puede ser parte de ella y el login la compara tal cual.

const INVISIBLES = /[\u200B-\u200D\u2060\uFEFF]/g;

/** Correo listo para enviar: NFKC, sin invisibles y sin espacios en los extremos. Conserva las mayúsculas. */
export function limpiarCorreoLogin(email: string): string {
  return String(email ?? "")
    .normalize("NFKC")
    .replace(INVISIBLES, "")
    .trim();
}
